export enum CalculationMethodType {
  Spreadsheets,
  Paper,
  Software,
  Other,
}
